export default __webpack_public_path__ + "static/media/ts.cc296740.svg";